import React from 'react';
import SiteWideStyles from './SiteWide.styles';
const SiteWide = ({ children, className }) => {
    return React.createElement(SiteWideStyles.Container, { className: className }, children);
};
export default SiteWide;
